import { render, staticRenderFns } from "./error-page.vue?vue&type=template&id=4bf94b44&scoped=true"
import script from "./error-page.vue?vue&type=script&lang=js"
export * from "./error-page.vue?vue&type=script&lang=js"
import style0 from "./error-page.vue?vue&type=style&index=0&id=4bf94b44&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf94b44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf94b44')) {
      api.createRecord('4bf94b44', component.options)
    } else {
      api.reload('4bf94b44', component.options)
    }
    module.hot.accept("./error-page.vue?vue&type=template&id=4bf94b44&scoped=true", function () {
      api.rerender('4bf94b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error-page.vue"
export default component.exports